import { type components } from "@zapier/api-clients/apis/templates-backend/types";
import { IconName } from "@zapier/zinnia-icons";

export const LOCALSTORAGE_TEMPLATE_CREATE_KEY = "createFromTemplateKey";

type ZSLAssetType = {
  name: keyof Pick<
    components["schemas"]["Template_Zsl"],
    | "interfaces"
    | "tables"
    | "chatbots"
    | "zaps"
    | "canvases"
    | "agents"
    | "mcp_servers"
  >;
  displayName: string;
  icon: IconName;
};

export const ZSL_ASSET_TYPES: ZSLAssetType[] = [
  {
    name: "zaps",
    displayName: "Zaps",
    icon: "miscBoltAltFill",
  },
  {
    name: "tables",
    displayName: "Tables",
    icon: "navTables",
  },
  {
    name: "interfaces",
    displayName: "Forms",
    icon: "navInterfaces",
  },
  {
    name: "chatbots",
    displayName: "Chatbots",
    icon: "navAIChatbot",
  },
  {
    name: "canvases",
    displayName: "Canvases",
    icon: "navCanvas",
  },
  {
    name: "agents",
    displayName: "Agents",
    icon: "navAgents",
  },
  {
    name: "mcp_servers",
    displayName: "MCP Servers",
    icon: "navMCP",
  },
];
